﻿import { Suspense, useEffect } from "react";
import { initGlobalSecurity } from "../helpers/globalSecurity";
import { initSession } from "../helpers/api";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/calculator.css";
import "../css/style.css";
import Header from "./Header";
import Main from "./Main";
import Footer_uat from "./Footer_uat";

var BASE_URL = window.location.origin + "/admin";
var FRONT_BASE_URL = window.location.origin;
const FILE_BASE_URL = window.location.origin;

const HEADER_AUTH = {
  get Authorization() {
    return localStorage.getItem("tkn") || "";
  },
  set Authorization(val) {
    if (val) localStorage.setItem("tkn", val);
  },
};

const OTHER_HEADER = {
  "Content-Type": "multipart/form-data",
  get Authorization() {
    return localStorage.getItem("tkn") || "";
  },
  set Authorization(val) {
    if (val) localStorage.setItem("tkn", val);
  },
};

const App = (props) => {
  useEffect(() => {
    initGlobalSecurity();
    initSession();
  }, []);

  return (
    <div id="main">
      <Suspense fallback={null}>
        <Header hidesidebar={null} />
      </Suspense>
      <Suspense fallback={null}>
        <Main />
      </Suspense>
      <Suspense style={{ height: "120px", background: "#f1f1f1" }} fallback={null}>
        <Footer_uat />
      </Suspense>
    </div>
  );
};

export default App;

export { BASE_URL, FRONT_BASE_URL, FILE_BASE_URL, HEADER_AUTH, OTHER_HEADER };
